<div class="step-container" *transloco="let t">
	<!-- Only show the progress bar when doing a local network scan. Makes no sense otherwise. -->
	@if (claimingMethod === 'ClaimByTokenOnLocalNetwork' || loadingData) {
		<prism-progress-indicator
			slot="dialog-progress-indicator"
			mode="indeterminate"
			id="sh-claimng-result-progress-bar"
		/>
	}

	<!-- Show org switcher for claim-by-link selection flow -->
	@if (stepConfig.isClaimByLinkSelection()) {
		<div class="sh-organization-switcher-container">
			<prism-label-value data-testid="organization-name-label-value">
				<span slot="label">{{
					t('cloud.add-devices-dialog.claim-by-qr-code.organization-owning-devices')
				}}</span>
				{{ organizationName() }}
			</prism-label-value>
			<prism-button data-testid="sh-change-org-button" variant="bright" (click)="onSwitchOrganizationClick()">
				{{ t('cloud.shared.switch-org.change') }}
			</prism-button>
		</div>
		<div class="prism-caption sh-org-refresh-message">
			{{ t('cloud.add-devices-dialog.claim-by-qr-code.changing-organization-will-refresh-message') }}
		</div>
	}

	@if (claimingMethod === 'ClaimByMacSerialSingle' && !stepConfig.isClaimByLinkSelection()) {
		<p id="add-devices-step2-mac-serial-title">{{ t('cloud.add-devices-dialog.confirm-device-details') }}.</p>
	}

	@if (stepConfig.isClaimByLinkSelection() && claimingMethod === 'ClaimByMacSerialSingle') {
		<p id="add-devices-step2-mac-serial-title">{{ t('cloud.add-devices-dialog.select-devices') }}.</p>
	}

	@if (claimingMethod === 'ClaimByMacSerialCsv') {
		<p id="add-devices-step2-mac-serial-title">
			@if (stepConfig.extractedDevices().length === 1) {
				{{ t('cloud.add-devices-dialog.csv-file-read-msg-singular') }}
			} @else {
				{{
					t('cloud.add-devices-dialog.csv-file-read-msg-plural', { x: stepConfig.extractedDevices().length })
				}}
			}
			{{ t('cloud.add-devices-dialog.select-devices') }}.
		</p>
	}
	@if (claimingMethod === 'ClaimByTokenOnLocalNetwork') {
		<p id="add-devices-step2-local-scan-title">
			{{ t('cloud.add-devices-dialog.scanning-for-devices-local-network') }}
		</p>
	}

	@if (claimingMethod === 'ClaimByTokenOnLocalNetwork') {
		<div class="local-network-table-container">
			<sh-local-network-table
				id="sh-devices-local-network-table"
				class="sh-local-network-table"
				[devices]="discoveredDevices$ | async"
				(selectionChange)="onSelectionChange($event)"
			>
			</sh-local-network-table>
		</div>
	} @else if (claimingMethod === 'ClaimByMacSerialSingle' || claimingMethod === 'ClaimByMacSerialCsv') {
		<sh-mac-serial-table
			id="sh-devices-mac-serial-table"
			class="sh-mac-serial-table"
			[devices]="stepConfig.extractedDevices()"
			(selectionChange)="onSelectionChange($event)"
		>
		</sh-mac-serial-table>
	} @else if (claimingMethod === 'ClaimByQrCode') {
		@if (stepConfig.activeQrCodeClaimStep() === qrCodeClaimStepEnum.Scan) {
			<sh-qr-code-scan-step></sh-qr-code-scan-step>
		} @else {
			<sh-mac-serial-table
				id="sh-devices-mac-serial-table"
				class="sh-mac-serial-table"
				[devices]="stepConfig.extractedDevices()"
				(selectionChange)="onSelectionChange($event)"
			>
			</sh-mac-serial-table>
		}
	}
</div>
